import Vue from 'vue'
import VueRouter from 'vue-router'

import AccessToken from '@/helpers/access-token'
import Login from '@/views/login/login.vue'
import FormCollectDataGW from '@/views/forms/collect-data-gw.vue'
import FormCollectDataGWFollow from '@/views/forms/collect-data-gw-follow.vue'
import FormQueryDataGW from '@/views/forms/query-data-gw.vue'
import ListForms from '@/views/forms/list-forms.vue'
import ListContacts from '@/views/contacts/list-contacts.vue'
import DetailContact from '@/views/contacts/detail-contact.vue'
import Dashboard from '@/views/general/dashboard.vue'
import ListProject from '@/views/projects/list-project.vue'
import DetailProject from '@/views/projects/detail-project.vue'
import NoAccess from '@/views/general/no-access.vue'
import Config from '@/Config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_backoffice')) return next({ name: 'new-form-collect-data-gw' })
      return next()
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/403',
    name: 'no-access',
    component: NoAccess
  },
  {
    path: '/form',
    name: 'list-form',
    component: ListForms,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_backoffice')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/form/collect-data-gw/new',
    name: 'new-form-collect-data-gw',
    component: FormCollectDataGW
  },
  {
    path: '/form/query-data-gw/new',
    name: 'new-form-query-data-gw',
    component: FormQueryDataGW
  },
  {
    path: '/form/collect-data-gw/:id',
    name: 'form-collect-data-gw',
    component: FormCollectDataGW
  },
  {
    path: '/form/collect-data-gw/:id/follow',
    name: 'form-collect-data-gw-follow',
    component: FormCollectDataGWFollow,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterForm')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/contact',
    name: 'list-contact',
    component: ListContacts,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/contact/new',
    name: 'new-contact',
    component: DetailContact,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/contact/:id',
    name: 'detail-contact',
    component: DetailContact,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || (!AccessToken.get().hasRight('datalake_backoffice'))) return next({ name: 'no-access' })
      return next()
    }
  },
  {
    path: '/project',
    name: 'list-project',
    component: ListProject,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/project/new',
    name: 'new-project',
    component: DetailProject,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  },
  {
    path: '/project/:id',
    name: 'detail-project',
    component: DetailProject,
    beforeEnter: (to, form, next) => {
      if (AccessToken.get() === null || !AccessToken.get().hasRight('datalake_alterCommonData')) return next({ name: 'dashboard' })
      return next()
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: Config.basePath,
  routes
})

export default router
